export default __webpack_public_path__ + "static/media/device-models-phone-large0.aceb816b.jpg";